import { Box, Divider, makeStyles } from '@material-ui/core';
import React, { FC, useEffect } from 'react';
import EditBtn from 'src/components/editor/EditBtnRegurcy';
import EditBtnAgain from 'src/components/editor/EditBtnAgainRegurcy';
import EditMultiBtn from 'src/components/editor/EditMultiBtn';
import EditMultiOption from 'src/components/editor/EditMultiOptionRegurcy';
import EditMultiSurvey from 'src/components/editor/EditMultiSurvey';
import EditRadius from 'src/components/editor/EditRadiusRegurcy';
import { RootState, useSelector } from 'src/store';

const TRANS_MULTI_BTN: any = {
  multi_button: 'multi_button',
  multi_sub_button: 'multi_sub_button',
  multi_left_button: 'multi_left_button',
  multi_right_button: 'multi_right_button',
  multi_textarea: 'multi_textarea',
  none_survey: 'option_button',
  multi_action_survey: 'selected_option_button'
};
const useStyles = makeStyles({
  divider: {
    height: '2px'
  }
});
const Button: any = ({ datas }: any) => {
  const classes = useStyles();
  let btnType = useSelector((state: RootState) => state.buttons.btnType);
  let switchImageType = useSelector(
    (state: RootState) => state.switchButton.switchImageType
  );

  if (datas?.convert && btnType === 'single') {
    datas.btnType = [
      'image_button',
      'bottom_left_button',
      'bottom_right_button'
    ];
  } else if (datas?.convert && btnType === 'double') {
    datas.btnType = [
      'image_left_button',
      'image_right_button',
      'bottom_left_button',
      'bottom_right_button'
    ];
  }

  if (datas?.switchImageType && switchImageType === 'double') {
    datas.btnType = ['top_image_button', 'bottom_image_button', 'close_button'];
  } else if (datas?.switchImageType && switchImageType === 'quard') {
    datas.btnType = [
      'top_left_image_button',
      'top_right_image_button',
      'bottom_left_image_button',
      'bottom_right_image_button',
      'close_button'
    ];
  }
  return (
    <Box>
      {datas?.btnType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditBtn
              menuTitle={type
                .split('_')
                .join(' ')
                .toUpperCase()
                .replace('MULTI ', '')}
              type={type}
            />
            {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
              <EditRadius
                menuTitle={type
                  .split('_')
                  .join(' ')
                  .toUpperCase()}
                type={type}
                max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
              />
            )}
            {datas?.againType && type === datas?.againType?.[0] && (
              <EditBtnAgain
                menuTitle={datas?.againType?.[0]
                  .split('_')
                  .join(' ')
                  .toUpperCase()}
                type={datas?.againType?.[0]}
              />
            )}
            <Divider className={classes.divider} />
          </div>
        );
      })}
      {datas?.multiBtnType &&
        datas?.multiBtnType?.indexOf('multi_action_survey') !== -1 && (
          <>
            <EditMultiOption />
            <EditMultiSurvey type="multi_action_survey" />
            <Divider className={classes.divider} />
          </>
        )}
      {datas?.multiBtnType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditMultiBtn
              menuTitle={TRANS_MULTI_BTN[type]
                .split('_')
                .join(' ')
                .toUpperCase()
                .replace('MULTI ', '')}
              type={type}
            />
            {datas?.radiusType && datas?.radiusType?.indexOf(type) !== -1 && (
              <EditRadius
                menuTitle={type
                  .split('_')
                  .join(' ')
                  .toUpperCase()
                  .replace('MULTI ', '')}
                type={type}
                max={datas?.radiusMax?.[datas?.radiusType?.indexOf(type)]}
              />
            )}
            {datas?.againType && type === datas?.againType?.[0] && (
              <EditBtnAgain
                menuTitle={datas?.againType?.[0]
                  .split('_')
                  .join(' ')
                  .toUpperCase()
                  .replace('MULTI ', '')}
                type={datas?.againType?.[0]}
              />
            )}
            <Divider className={classes.divider} />
          </div>
        );
      })}
    </Box>
  );
};

export default Button;
